module.exports = __webpack_public_path__ + "images/FUSA_icons/044-sales.f2f59c5afdffceb07fe01aed5b29e520.svg";